<template>
  <div class="timeout-transfer">
    <div>
      <md-icon
        class="icon"
        md-src="/static/images/icon-alert-yellow.svg"
      />
    </div>
    <div>
      <p>
        O processo de transferência está muito lento.
        <br>Pedimos que faça contato com o suporte.
        Ligue para <span>0800 643 8100</span>, opção 3.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailedTransfer'
}
</script>

<style lang="scss">
.timeout-transfer {
  text-align: center;
  .icon {
    width: 80px;
    height: 80px;
  }

  p {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    line-height: 22px;
    font-size: 15px;
    text-align: center;
    color: #617173;
    font-weight: 400;

    span {
      font-weight: bold;
    }
  }
}
</style>
